common.View.create('website::layouts.Main', {

    onDOMLoad()
    {
        if (!$('html').hasClass('isAdmin')) {
            this.initCkEditorButtons();
        }

        this.initAnimations();
    },

    initCkEditorButtons()
    {
        const buttons = document.querySelectorAll(".canvas\\:\\:Canvas .canvas\\:\\:canvas-blocks-utils-text-Block  a.btn-default-icon-ck");

        buttons.forEach(function (button) {
            const text = button.textContent;

            const span = document.createElement('span');
            span.textContent = text;

            button.textContent = '';

            button.appendChild(span);
        });
    },

    initAnimations() {
        let sal = require('sal.js');

        sal({
            threshold: 0.1,
            once: true,
        });
    },
});
